<template>
  <div class="section py-0">
    <div class="section" v-if="user">
      <div class="columns">
        <div class="column">
          <h2 class="title is-4">
            {{ user.salutation }} {{ user.first_name }} {{ user.last_name }}
          </h2>
        </div>
        <div class="column is-narrow is-flex">
          <iconRow
            :data="user.products_subscribed"
            dataClass="mr-2"
            dataSize="is-medium"
          />
          <userTag :data="user.type" dataSize="is-medium" />
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="columns is-desktop">
        <div class="column is-half-desktop">
          <div class="columns">
            <div class="column set-height">
              <h4 class="title is-3">Profil</h4>
            </div>
            <div
              v-if="isPermited(['org_admin', 'admin']) && me.id !== user.id"
              class="column is-narrow"
            >
              <div class="buttons">
                <b-button class="is-light" @click="confirmDeleteUser">
                  <b-icon icon="trash-alt"></b-icon>
                </b-button>
              </div>
            </div>
          </div>
          <UserSimple @submit="updateUser" :user="user" />
        </div>
        <div class="column is-half-dekstop">
          <div class="columns">
            <div class="column set-height">
              <h4 class="title is-3">Organisation</h4>
            </div>
          </div>
          <OrgPreview :orgId="user.org_id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import iconRow from '@/components/helper/IconRow.vue';
import userTag from '@/components/editUser/UserTag.vue';

import UserSimple from '@/components/editUser/UserSimple.vue';
import OrgPreview from '@/components/editOrg/OrgPreview.vue';

export default {
  name: 'ViewUser',
  // metaInfo: {
  //   title: 'Nutzer',
  // },
  components: {
    iconRow,
    userTag,
    UserSimple,
    OrgPreview,
  },
  data() {
    return {
      active: 0,
    };
  },
  props: ['userId'],
  computed: {
    user() {
      if (this.userId) {
        return this.userById(this.userId);
      }
      return this.me;
    },
    ...mapGetters({
      me: 'user/me',
      error: 'user/error',
      userById: 'user/dataById',
      isPermited: 'user/isPermited',
    }),
  },
  methods: {
    updateUser(user) {
      if (this.isPermited('user')) {
        this.$store.dispatch('user/UPDATE', {
          id: user.id,
          salutation: user.salutation,
          first_name: user.first_name,
          last_name: user.last_name,
          department: user.department === null ? '' : user.department,
          phone: user.phone,
        });
      } else {
        this.$store.dispatch('user/UPDATE', {
          id: user.id,
          salutation: user.salutation,
          first_name: user.first_name,
          last_name: user.last_name,
          type: user.type,
          department: user.department === null ? '' : user.department,
          phone: user.phone,
        });
      }
    },
    deleteUser(user) {
      this.$store.dispatch('user/DELETE', { id: user.id });
    },
    confirmDeleteUser() {
      this.$buefy.dialog.confirm({
        title: 'Account löschen',
        message: `Sind Sie sicher, dass Sie das Konto von ${this.user.first_name} ${this.user.last_name} <b>löschen</b> wollen? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: 'Account löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteUser(this.user),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.set-height {
  height: 65px;
}
</style>
